<div mat-dialog-title style="display:flex; flex-direction: row; flex-wrap: wrap;">
    <div><h3>Details: {{filterLabel}}</h3></div>
    <div style="margin-left: auto; padding-top: 24px;"><button mat-button color="primary" [disabled]="loadingData ||  faultList.length == 0"  (click)="downloadAsCSV()"><mat-icon style="font-size: 24px; width: 24px; height: 24px; line-height: 24px;">download</mat-icon> Download</button></div>
</div>

<div mat-dialog-content style="overflow: auto;">
    <div *ngIf="!loadingData">
          <mat-table [dataSource]="faultList" class="gea-mat-table">

            <ng-container matColumnDef="ShiftDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Shift Date</mat-header-cell>
                <mat-cell *matCellDef="let d">
                    <div class="fx-column-start-start">
                        <div>
                            <div class="dataHeader">Shift Date</div>
                            <div class="dataValue">{{d.ShiftDate | date:'MM/dd/yyyy'}}</div>
                        </div>
                        <div>
                            <div class="dataHeader">Shift</div>
                            <div class="dataValue"> {{d.Shift}}</div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Hour">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Hour</mat-header-cell>
                <mat-cell *matCellDef="let d">{{d.Hour}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="FaultTime">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Fault Time</mat-header-cell>
                <mat-cell *matCellDef="let d">
                    <div class="fx-column-start-start">
                        <div>
                            <div class="dataHeader">Start</div>
                            <div class="dataValue">{{d.StartTime | date:'MM/dd/yyyy HH:mm:ss'}}</div>
                        </div>
                        <div>
                            <div class="dataHeader">End</div>
                            <div class="dataValue">{{d.EndTime | date:'MM/dd/yyyy HH:mm:ss'}}</div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>
   
            <ng-container matColumnDef="Downtime">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Duration</mat-header-cell>
                <mat-cell *matCellDef="let d">{{formatDuration(d.Downtime)}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="FaultMessage">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Fault</mat-header-cell>
                <mat-cell *matCellDef="let d">
                    <div class="faultMessage">
                        <div *ngIf="inData.objectType == 'GROUP'" class="faultSource">{{d.FaultObjectDescription}}</div>
                        <div>{{d.FaultMessage}}</div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="RootCause">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Root Cause</mat-header-cell>
                <mat-cell *matCellDef="let d">
                    <div class="fx-column-start-start">
                        <div>
                            <div class="dataHeader">Level 1</div>
                            <div class="dataValue">{{d.RootCause_Level1}}</div>
                        </div>
                        <div *ngIf="d.RootCause_Level2 && d.RootCause_Level2.trim() != ''">
                            <div class="dataHeader">Level 2</div>
                            <div class="dataValue">{{d.RootCause_Level2}}</div>
                        </div>
                        <div *ngIf="d.RootCause_Level3 && d.RootCause_Level3.trim() != ''">
                            <div class="dataHeader">Level 3</div>
                            <div class="dataValue" >{{d.RootCause_Level3}}</div>
                        </div>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Notes">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Comment</mat-header-cell>
                <mat-cell *matCellDef="let d">{{d.Notes}}</mat-cell>
            </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>          
          </mat-table>
    </div>
    <div *ngIf="loadingData">
          <mat-spinner>Loading...</mat-spinner>
    </div>
</div>

<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="close()">Close</button>
</div>